const updates = [
  { date: '07-30', tag: '新片上线', title: '《奥本海默》导演剪辑版独家上线，新增30分钟未曝光片段', time: '2小时前' },
  { date: '07-29', tag: '剧集更新', title: '《庆余年2》全集一次性放出，会员抢先看大结局', time: '昨天' },
  { date: '07-29', tag: '综艺', title: '《歌手2026》总决赛直播回放已上线，重温精彩瞬间', time: '昨天' },
  { date: '07-28', tag: '动漫', title: '《雾山五行》最终章上线，国产动画巅峰之作', time: '2天前' },
  { date: '07-28', tag: '新片上线', title: '《沙丘3》4K超清版上线，科幻史诗视觉盛宴', time: '2天前' },
  { date: '07-27', tag: '纪录片', title: '《舌尖上的中国》第五季全集上线，美食之旅再出发', time: '3天前' },
  { date: '07-27', tag: '剧集更新', title: '《隐秘的角落》原班人马新作《沉默的真相》开播', time: '3天前' },
  { date: '07-26', tag: '新片上线', title: '《流浪地球3》独家幕后纪录片全网上线', time: '4天前' },
];

const tagColors: Record<string, string> = {
  '新片上线': 'bg-primary-100 text-primary-700',
  '剧集更新': 'bg-accent-100 text-accent-700',
  '综艺': 'bg-secondary-100 text-secondary-700',
  '动漫': 'bg-accent-100 text-accent-700',
  '纪录片': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            实时追踪影视更新动态，最新上线内容一目了然
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-start gap-4 md:gap-6 py-4 md:py-5 border-b border-background-200/60 last:border-b-0 cursor-pointer hover:bg-background-100/50 -mx-3 px-3 rounded-lg transition-colors duration-150"
            >
              {/* Date */}
              <div className="flex-shrink-0 w-14 md:w-16 text-center">
                <div className="text-xs font-bold text-foreground-400 bg-background-100 rounded-lg py-2 px-1 whitespace-nowrap">
                  {item.date}
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1.5">
                  <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag}
                  </span>
                  <span className="text-[11px] text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors leading-relaxed">
                  {item.title}
                </h3>
              </div>

              {/* Arrow */}
              <div className="flex-shrink-0 flex items-center h-full pt-1">
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors text-lg"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}